module.exports = __webpack_public_path__ + "static/media/02.95eac385.jpeg";